import { FC } from 'react';
import {
  Stack,
  Tooltip,
  Box,
  Typography,
  Divider,
  ListItemText,
  MenuList,
  MenuItem,
  ListItemIcon,
  IconButton,
} from '@mui/material';
import { Close, Favorite, HeartBroken, MoreVertTwoTone } from '@mui/icons-material';

import { IconButtonDropdown } from '@cvt/components/ButtonDropdown';

import { useDisciplineCrud } from '../hooks/useDisciplineCrud';

export const DisciplineOptionsScheduled: FC<Disciplines.Discipline> = discipline => {

  return (
    <Stack direction="row" spacing={1}>
      <DisciplineOptionsMore {...discipline} />
    </Stack>
  );
};

export const DisciplineOptionsMore: FC<Disciplines.Discipline> = discipline => {

  const { likeDiscipline, unlikeDiscipline, ignoreDiscipline } = useDisciplineCrud();

  const optionsDisabled = [likeDiscipline.isPending, unlikeDiscipline.isPending, ignoreDiscipline.isPending].some(value => value); 

  return (
    <Box color="grey.500">
      <Tooltip title="More">
        <IconButtonDropdown
          buttonProps={{
            color: 'inherit',
          }}
          content={({ closeDropdown }) => (
            <Box>
              <Box bgcolor="secondary.light" px={2} py={1}>
                <Typography variant="h3">Options</Typography>
              </Box>
              <Divider/>
              <MenuList>
                {discipline.match.isFavourite ? (
                  <MenuItem onClick={() => [unlikeDiscipline.mutateAsync(discipline.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <HeartBroken fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unfavourite</ListItemText>
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => [likeDiscipline.mutateAsync(discipline.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <Favorite fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Favorite</ListItemText>
                  </MenuItem>
                )}
                <MenuItem onClick={() => [ignoreDiscipline.mutateAsync(discipline.id), closeDropdown()]} disabled={optionsDisabled}>
                  <ListItemIcon>
                    <Close fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Not interested</ListItemText>
                </MenuItem>
              </MenuList>
            </Box>
          )}
        >
          <MoreVertTwoTone/>
        </IconButtonDropdown>
      </Tooltip>
    </Box>
  );
};

export const DisciplineOptions: FC<Disciplines.Discipline> = discipline => {
  const { likeDiscipline, unlikeDiscipline, ignoreDiscipline } = useDisciplineCrud();

  const optionsDisabled = [likeDiscipline.isPending, unlikeDiscipline.isPending, ignoreDiscipline.isPending].some(value => value); 

  return (
    <>
      {discipline.match.isFavourite && (
        <IconButton onClick={() => unlikeDiscipline.mutateAsync(discipline.id)} color="error" disabled={optionsDisabled}>
          <Favorite fontSize="small" />
        </IconButton>
      )}
      <DisciplineOptionsMore {...discipline} />
    </>
  );
};
